import type { RootState } from './store';

export const selectConfig = (state: RootState) => state.core.config;

export const selectGlobalError = (state: RootState) => state.core.globalError;
